export default __webpack_public_path__ + "a9db0ef7b7471f7c61dd3916b8608c36.svg";